export default {
  FETCH_SCHOOLS: 'fetchSchools',
  FETCH_SCHOOL_TYPES: 'fetchSchoolTypes',
  FETCH_MUNICIPALITIES: 'fetchMunicipalities',
  FETCH_RLVTYPES: 'fetchRLVClassificationTypes',
  FETCH_SCHOOL_BY_ID: 'fetchSchoolById',
  SAVE_CHANGES: 'saveSchoolChanges',
  FETCH_RESULTS: 'fetchResults',
};
